import React from "react";
import "./index.css"

const pricingData = {
    headers: ["FEATURE", "EVERBARY", "COMPETITOR 1", "COMPETITOR 2"],
    rows: [
        {
            feature: "Pricing",
            featureClass: "text-[32px] font-[Montserrat] leading-[32px] self-center border-t-2 border-b-[1px] border-white font-bold text-black",
            values: ["$24.95/page", "$25/page", "$35/page"],
        },
        {
            feature: "Turnaround Times",
            featureClass: "text-[32px] font-[Montserrat] leading-[32px] text-left self-center border-t-[1px] border-b-2 border-white font-bold",
            values: ["24h", "24h", "24h"],
            highlightIndex: 0,
        },
        {
            feature: "Faster Option",
            featureClass: "text-[32px] text-left font-[Montserrat] font-bold leading-[32px] self-center",
            values: [
                <div className="leading-[45px]">
                    <p className="text-center">4h → $9.98/page</p>
                    <p className="text-center text-[24px] text-black">
                        (Included on your first five orders)
                    </p>
                </div>,
                "12h → $14.95/page",
                "6h → $55/page",
            ],
        },
        {
            feature: "QA",
            featureClass: "text-[32px] font-[Montserrat] font-bold leading-[32px] self-center border-t-2 border-b-[1px] border-white",
            values: ["Included", "$14.95/page", "$20/page"],
        },
        {
            feature: "Payments",
            featureClass: "text-[32px] font-[Montserrat] font-bold leading-[32px] border-t-[1px] border-b-[1px] border-white",
            values: [
                <>
                    <div className="w-full font-normal leading-[45px] ">
                        <p className="text-left pl-[30px]">Flexible:</p>
                        <p className="text-left pl-[60px]">- Pay Later</p>
                        <p className="text-left pl-[60px]">- Share payment links</p>
                        <p className="text-left pl-[60px]">- Pay monthly</p>
                        <p className="text-left pl-[60px]">- Pay weekly</p>
                        <p className="text-left pl-[60px]">- Pay at custom schedule</p>
                    </div>
                </>,
                <div className="flex flex-col justify-start items-start leading-10">
                    <div className="w-full font-normal leading-[45px] ">
                        <p className="text-left pl-[30px]">Flexible:</p>
                        <p className="text-left pl-[60px]">- Pay Later</p>
                        <p className="text-left pl-[60px]">- Share payment links</p>
                    </div>

                </div>,
                <div className="w-full text-center">Upfront</div>,
            ],
        },
    ],
};

const PricingRow = ({ feature, featureClass, values, highlightIndex }) => (
    <>
        <div className={`priceTableHeaderText priceTableHeaderTextMaxMd text-left ${feature === "Payments" ? "border-b-0 pb-[30px]" : "border-b-[1px]"} border-[#000]/20 pl-[30px]`}>{feature}</div>
        {values.map((val, i) => (
            <div
                key={i}
                className={`priceTableHeaderText font-normal ${feature === "Payments" ? "border-b-0 pb-[30px]" : "border-b-[1px]"} border-[#000]/20  text-center  text-[1.85rem]  ${highlightIndex === i ? "font-normal" : ""
                    } ${i === 0 ? "bg-[rgba(18,171,191,0.40)]" : ""}`}
            >
                {val}
                
            </div>
        ))}
    </>
);

const PricingTable = ({ id }) => {
    return (
        <div className="pricingSectionContainer max-md:my-[40px]" id={id}>
            <div className="pricingSection mx-auto bg-[#fff]">
                <div className="w-full grid auto-rows-auto max-md:grid-cols-1 grid-cols-[250px_1.3fr_1fr_1fr]" >
                    {pricingData.headers.map((header, i) => (
                        <div
                            key={i}
                            className={`priceTableHeaderText pt-[30px] ${i === 1 ? "bg-[rgba(18,171,191,0.40)]" : ""} ${i === 0 ? "text-left max-md:text-center pl-[30px]" : ""} ${i !== 0 ? 'flex items-center justify-center' : ''}`}
                        >
                            {/* {header} */}
                            {header === "EVERBARY" ? <img src={require("../../../../assets/logo.png")} alt="everbary" width={200} /> : header}

                        </div>
                    ))}

                    {pricingData.rows.map((row, idx) => (
                        <PricingRow key={idx} {...row} />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default PricingTable;
